import { useQuery } from '@apollo/client';
import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useState } from 'react';

import usePaymentMethod from '@hooks/usePaymentMethod';

import { keysToCamel } from '@utils/butter';

import { IAccountInfoQueryData } from '@folx-types/member';

import ACCOUNT_INFO_QUERY from '@graphql/queries/AccountInfo.query.gql';

import PaymentEditStep from './PaymentEditStep.component';

interface IPaymentEditStepPageProps {
	path?: string;
}

export interface IPaymentEditPageContent {
	butterPage: {
		title: string;
		info: string;
		cardNumberLabel: string;
		expDateLabel: string;
		cvvLabel: string;
		genericError: string;
	};
}

const PaymentEditStepPage: FC<IPaymentEditStepPageProps> = () => {
	const butterData = useStaticQuery<Record<string, string>>(
		graphql`
			{
				butterPage(slug: { eq: "mssp-payment-edit-page" }) {
					title
					info
					card_number_label
					exp_date_label
					cvv_label
					generic_error
				}
			}
		`
	);

	console.log(butterData);

	const {
		loading: accountLoading,
		data: accountData,
		error: accountError,
	} = useQuery<IAccountInfoQueryData>(ACCOUNT_INFO_QUERY);

	const {
		value: paymentMethod,
		loading: paymentMethodLoading,
		error: paymentMethodError,
	} = usePaymentMethod();

	const member = accountData?.currentMember;

	const refinedContent: IPaymentEditPageContent = keysToCamel(
		butterData
	) as IPaymentEditPageContent;

	return (
		<PaymentEditStep
			paymentMethod={paymentMethod}
			member={member}
			refinedContent={refinedContent}
		/>
	);
};

export default PaymentEditStepPage;
